export default __webpack_public_path__ + "static/media/step1-section3.b4a3b9d7.png";